var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 10,
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1364_9966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3125 11.5H18.6875C16.1094 11.5 14 13.5925 14 16.15V37.85C14 40.4075 16.1094 42.5 18.6875 42.5H31.4531C32.7031 42.5 33.8906 42.0195 34.7656 41.136L37.625 38.2995C38.5156 37.4315 39 36.2535 39 35.0135V16.15C39 13.5925 36.8906 11.5 34.3125 11.5ZM28.0625 34.75H21.8125C20.9531 34.75 20.25 34.0525 20.25 33.2C20.25 32.3475 20.9531 31.65 21.8125 31.65H28.0625C28.9219 31.65 29.625 32.3475 29.625 33.2C29.625 34.0525 28.9219 34.75 28.0625 34.75ZM31.1875 28.55H21.8125C20.9531 28.55 20.25 27.8525 20.25 27C20.25 26.1475 20.9531 25.45 21.8125 25.45H31.1875C32.0469 25.45 32.75 26.1475 32.75 27C32.75 27.8525 32.0469 28.55 31.1875 28.55ZM31.1875 22.35H21.8125C20.9531 22.35 20.25 21.6525 20.25 20.8C20.25 19.9475 20.9531 19.25 21.8125 19.25H31.1875C32.0469 19.25 32.75 19.9475 32.75 20.8C32.75 21.6525 32.0469 22.35 31.1875 22.35Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1364_9966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 31,
    fill: "white",
    transform: "translate(14 11.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacDocument);
export default __webpack_public_path__ + "static/media/contac_document.f44ce8db9395bb9d92c7769bca99619f.svg";
export { ForwardRef as ReactComponent };